type FlutterMessage = {
  postMessage: (message: string) => void;
};

declare global {
  // eslint-disable-next-line no-var
  var platformShare: FlutterMessage;
}

function isNativeShareAvailable(): boolean {
  return navigator.share != undefined;
}

function isPlatformShareAvailable(): boolean {
  return window.platformShare != undefined;
}

export function isShareAvailable(): boolean {
  return isNativeShareAvailable() || isPlatformShareAvailable();
}

export function share(shareData: ShareData) {
  if (isNativeShareAvailable()) {
    return navigator.share(shareData);
  }

  if (isPlatformShareAvailable()) {
    const shareMessage = JSON.stringify(shareData);
    return window.platformShare.postMessage(shareMessage);
  }

  throw new Error('Share is not available on this platform');
}
